import {all, takeEvery, put, call } from 'redux-saga/effects';

import actions from "./actions"
import {getPayments, getPaymentStatuses} from "../../services/payment.service";
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";

export function* GET_ALL_PAYMENTS(){
    yield put({ type: actions.SET_ALL_PAYMENTS_LOADING });
    try{
        const response: AxiosResponse<any> = yield call(getPayments);
        // Wysylamy zawsze, takze przy pustej odpowiedzi. Wczesniejszy warunek
        // `if(response.data)` powodowal, ze brak danych zostawial ekran
        // w stanie wczytywania na zawsze.
        yield put({
            type: actions.SET_ALL_PAYMENTS,
            payload: response.data || []
        })
    } catch (e) {
        logError("payment/GET_ALL_PAYMENTS", e);
        yield put({ type: actions.SET_ALL_PAYMENTS_ERROR });
    }
}


export function* GET_PAYMENT_STATUSES(){
    try{
        const response: AxiosResponse<any> = yield call(getPaymentStatuses);
        yield put({
            type: actions.SET_PAYMENT_STATUSES,
            payload: response.data || []
        })
    } catch (e) {
        logError("payment/GET_PAYMENT_STATUSES", e);
    }
}



export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_ALL_PAYMENTS, GET_ALL_PAYMENTS),
        takeEvery(actions.GET_PAYMENT_STATUSES, GET_PAYMENT_STATUSES)
    ])
}
